import { render, staticRenderFns } from "./StudentParentInfoPage.vue?vue&type=template&id=a58e3ee2&"
import script from "./StudentParentInfoPage.vue?vue&type=script&lang=ts&"
export * from "./StudentParentInfoPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports